//#. Vuex Type Script
//#. Version		          : 1.0.0.0
//#. Template Modified Date : 12-MAR-2020 10:00:00 AM
//#. File Created Date      : 12-MAR-2020 10:00:00 AM
import { Module } from "vuex";
import { RootState } from "./../../types";
import { App } from "./types";
import { getters } from './getters';
import { mutations } from "./mutations";
import { actions } from "./actions";
const namespaced: boolean = true;

//#. An object containing the data
export const state: App = {
    about: {
        enabled: false,
        copyRight: '&#169 PanApps, All Rights Reserved',
        title: 'About'
    },
    authorized: false,
    loggedInUser: '',
    userId: 0,
    avatar: '',
    applicationName: 'IUCN Grants Portal',
    accountingLocation: '',
    actions: {
        list: '/api/Dashboard/CreateMenu',
        getTemplates: '/api/Dashboard/GetTemplate/'
    },
    buttons: {
        enabled: true,
        btn: [
            {
                icon: 'mdi-magnify',
                fontSize: '20',
                count: 0,
                color: '',
                name: 'search',
                tooltip: 'Search'
            },
            {
                icon: 'mdi-view-dashboard',
                fontSize: '20',
                count: 0,
                color: '',
                name: 'modules',
                tooltip: 'Module Groups'
            },
            {
                icon: 'mdi-bell',
                fontSize: '20',
                color: '',
                count: 5,
                name: 'notify',
                tooltip: 'Notifications'
            },
            {
                icon: 'mdi-bullhorn',
                fontSize: '23',
                color: '',
                count: 0,
                name: 'announce',
                tooltip: 'Announcements'
            },
            {
                icon: 'mdi-account-circle',
                fontSize: '30',
                count: 0,
                color: '',
                name: 'profile',
                tooltip: ''
            }
        ]
    },
    breadcrumbs: {
        enabled: false,
        list: []
    },    
    files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-json',
        md: 'mdi-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        usr: 'mdi-account-circle',
        leaf: 'mdi-leaf',
        folder: 'mdi-folder-outline'
    },
    height: '0px!important',    
    hideHeader: window.location.pathname.includes('/Registration'),
    menu: {
        icons: false,
        tree: [],
        tabs: [],
        collection: [],
        openNodes: ['Masters', 'Reports', 'Transaction', 'Process'],
        cacheMenus: {
            module: '',
            tabs: ''
        },
        megaMenu: {
            enabled: false,
            text: 'PanERP covers key processes supported by modern ERP systems. It improves operational efficiency, accuracy and cost effectiveness of core business activities through industry best practices. PanERP workflow allows business users to define a sequence of activities that can be automatically or manually assigned to a user or set of users that will help complete a task.PanERP provides a range of information that can be easily accessed through tablets and mobile devices. Enables business managers and stakeholders to make quicker and smarter decisions on the go.	',
            title: "ERP Application Features",
            icon: ''
        }
    },
    moduleGroup: {
        container: true,
        icon: '',
        color: '',
        name: '',
        list: [],
        modules: [],
        cols: 0,
        tiles: [
            {
                breakpoint: "lg",
                breakpointWidth: 1200,
                numberOfCols: 6,
                iconSize: '80',
                items: [
                    { id: "1", x: 0, y: 0, width: 2, showOrder: 1, isDisabled: true, height: 1, background: '', icon: 'mdi-settings', title: 'Administration', details: 'System </br> Application', color: '#5cd65c' },
                    { id: "10", x: 4, y: 0, width: 2, showOrder: 2, isDisabled: true, height: 1, background: '', icon: 'mdi-file-cog', title: 'GMS', details: 'Applicant</ br > Reviewer </br> Admin', color: '#6292b6' }
                ]
            },
            {
                breakpoint: "md",
                breakpointWidth: 996,
                iconSize: '60',
                numberOfCols: 6,
                items: [
                    { id: "1", x: 0, y: 0, width: 2, showOrder: 1, isDisabled: true, height: 1, background: '', icon: 'mdi-settings', title: 'Administration', details: 'System </br> Application', color: '#5cd65c' },
                    { id: "10", x: 4, y: 0, width: 2, showOrder: 2, isDisabled: true, height: 1, background: '', icon: 'mdi-file-cog', title: 'GMS', details: 'Applicant</ br > Reviewer </br> Admin', color: '#6292b6' }
                ]
            },
            {
                breakpoint: "sm",
                breakpointWidth: 768,
                iconSize: '40',
                numberOfCols: 4,
                items: [
                    { id: "10", x: 2, y: 1, width: 1, showOrder: 1, isDisabled: true, height: 1, background: '', icon: 'mdi-file-cog', title: 'GMS', details: 'Applicant</ br > Reviewer </br> Admin', color: '#6292b6' },
                    { id: "1", x: 0, y: 0, width: 1, showOrder: 2, isDisabled: true, height: 1, background: '', icon: 'mdi-settings', title: 'Administration', details: 'System </br> Application', color: '#5cd65c' }
                ]
            }
        ],
    }, 
    announcement: false,
    profile: false,
    profileClose: false,
    profileClosePath: '',
    search: {
        enabled: true,
        container: false,
        menus: []
    },
    routers: []
};

export const RootApp: Module<App, RootState> = {
    namespaced,
    state,
    getters,
    mutations,
    actions,
};